module.exports = __webpack_public_path__ + "static/media/help-backgroundImg.43b21952.svg";